
/* styles */
require("!!../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../vue-loader/lib/style-compiler/index?{\"id\":\"data-v-cffcddbc\",\"scoped\":false,\"hasInlineConfig\":false}!../../vue-loader/lib/selector?type=styles&index=0!./Icon.vue")

var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!./Icon.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-cffcddbc\"}!../../vue-loader/lib/selector?type=template&index=0!./Icon.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/components/Icon.vue
// module id = 0
// module chunks = 1